var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"text-info"},[_vm._v("Загрузка скана не является обязательной, но мы должны иметь возможность проверить введённые паспортные данные. Вы можете предъявить паспорт лично, приехав к нам в офис.")])}
var staticRenderFns = []

export { render, staticRenderFns }